import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { handleChange, handleSubmit } from "../../controller/UserDefineController/CreateUserDefineController";
function CreateUserDefineField({ keyName, onClose, onSuccess, keyTypes, moduleList, selectedModule }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({ vc_Name: '', vc_Description: '', FK_KeyType_ID: '0', ModuleID: selectedModule });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        if (keyName) {
            debugger;
            setFormData({
                vc_Name: keyName.vc_Name,
                vc_Description: keyName.vc_Description,
                FK_KeyType_ID: keyName.FK_KeyType_ID,
                ModuleID: keyName.PK_SearchModule_ID
            });
        } else {
            setFormData({ vc_Name: '', vc_Description: '', FK_KeyType_ID: '0', ModuleID: selectedModule });
        }
    }, [keyName, selectedModule]);

    const handleFieldChange = (event) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleFormSubmit = async (event) => {
        debugger;
        event.preventDefault();
        try {
            if (keyName) {
                formData.ID = keyName.PK_KeyName_ID;
            } else {
                formData.ID = 0;
            }
            const redirectCallback = () => {
                navigate('/');
            };
            const redirectUserList = () => {
                navigate('/AdministrationSetting?saved=true');
            };
            handleSubmit(event, formData, setFormData, setErrors, () => {
                redirectCallback();
                onSuccess();
                onClose();
            }, () => {
                redirectUserList();
                onSuccess();
                onClose();
            });
        } catch (error) {
            console.error('Error saving Team:', error);
            setErrors({ submit: 'Error saving team. Please try again.' });
        }
    };

    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade" id="UserDefineModal" tabIndex="-1" aria-labelledby="UserDefineModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">{keyName ? 'Edit User Define Field' : 'Create User Define Field'}</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3" style={{"marginLeft":"5px","marginRight":"0px","marginTop":"10px"}}>
                                    <label htmlFor="ModuleID" className="col-sm-2 col-form-label">Select Module:</label>
                                    <div className="col-sm-10">
                                        <select name="ModuleID" className="form-control" onChange={handleFieldChange} value={formData.ModuleID}>
                                            <option value="0">Select Module</option>
                                            {moduleList.map((module) => (
                                                <option key={module.PK_SearchModule_ID} value={module.PK_SearchModule_ID}>
                                                    {module.vc_ModuleName}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.ModuleID && <div style={{ color: 'red' }}>{errors.ModuleID}</div>}
                                    </div>
                                </div>
                                <div className="row mb-3" style={{"marginLeft":"5px","marginRight":"0px"}}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Field Type:</label>
                                    <div className="col-sm-4">
                                        <select name="FK_KeyType_ID" className="form-control" onChange={handleFieldChange} value={formData.FK_KeyType_ID}>
                                            <option value="0">Select Field Type</option>
                                            {keyTypes.map((keyType) => (
                                                <option key={keyType.PK_KeyType_ID} value={keyType.PK_KeyType_ID}>
                                                    {keyType.vc_Name}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.FK_KeyType_ID && <div style={{ color: 'red' }}>{errors.FK_KeyType_ID}</div>}
                                    </div>
                                </div>
                                <div className="row mb-3" style={{"marginLeft":"5px","marginRight":"0px"}}>
                                    <label htmlFor="vc_Name" className="col-sm-2 col-form-label">Field Name:</label>
                                    <div className="col-sm-10">
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="vc_Name"
                                            name="vc_Name"
                                            value={formData.vc_Name}
                                            onChange={handleFieldChange}
                                        />
                                         {errors.vc_Name && <div style={{ color: 'red' }}>{errors.vc_Name}</div>}
                                    </div>
                                </div>
                                <div className="row mb-3" style={{"marginLeft":"5px","marginRight":"0px"}}>
                                    <label htmlFor="vc_Description" className="col-sm-2 col-form-label">Description:</label>
                                    <div className="col-sm-10">
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="vc_Description"
                                            name="vc_Description"
                                            value={formData.vc_Description}
                                            onChange={handleFieldChange}
                                        />
                                    </div>
                                </div>
                                {errors.submit && <div className="alert alert-danger">{errors.submit}</div>}
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                <i className="icofont-save" aria-hidden="true"> Save</i>
                                </button>
                                <button className="btn btn-secondary" type="button"  data-dismiss="modal" aria-label="Close">
                                <i className="icofont-close" aria-hidden="true"> Close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default CreateUserDefineField;
